import { h } from 'preact';

/**
 * type puede ser error, success, warning
 */
export default ({ children, type = 'error', visible = true }) => (!visible ? null : (
  <div>
    <div className={`w-alert-message w-${type}`}>
      <p className="w-alert-message-copy">{children}</p>
    </div>
  </div>
));



// WEBPACK FOOTER //
// ./components/generics/AlertMessage.js